import _objectSpread from "@babel/runtime/helpers/objectSpread2";
var _div, _span, _CardWrapper, _CardWrapper2, _CardWrapper3, _CardWrapper4, _CardWrapper5, _CardWrapper6, _CardWrapper7, _CardWrapper8, _CardWrapper9, _CardWrapper0, _CardWrapper1, _CardWrapper10, _CardWrapper11, _CardWrapper12, _CardWrapper13, _CardWrapper14, _CardWrapper15, _span2, _span3;
import ArrowRight from '@crehana/compass.icons.outline/ArrowRight';
import { CREHANA_BASE_URL_PRD } from '@crehana/constants';
import { useTranslation } from '@crehana/i18n';
import { useIsClient } from '@crehana/react-hooks';
import { LazyImage } from "../../LazyImage";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var articles = [
// 1
{
  image: {
    placeholder: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAIAAADZSiLoAAAAKUlEQVR4nAEeAOH/AVNUXvXm3v8NFAQCAwYI8vL99vsECO7k9+bm5/L23EEROcPavakAAAAASUVORK5CYII=',
    url: 'https://crehana-vercel-images-prd.imgix.net/public/ecommerce-mf/a5703db5-33f9-4146-bccd-c1caa39e8033-1.png?auto=format&fit=clip'
  },
  url: {
    absoluteUrl: /*#__PURE__*/"".concat(CREHANA_BASE_URL_PRD, "/blog/transformacion-cultural/evaluacion-desempeno/"),
    relativeUrl: '/blog/transformacion-cultural/evaluacion-desempeno/'
  },
  title: 'Evaluación de desempeño: ¿cómo medir el rendimiento de tu equipo de trabajo?'
},
// 2
{
  image: {
    placeholder: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAIAAADZSiLoAAAAKUlEQVR4nAEeAOH/AVNUXvXm3v8NFAQCAwYI8vL99vsECO7k9+bm5/L23EEROcPavakAAAAASUVORK5CYII=',
    url: 'https://crehana-vercel-images-prd.imgix.net/public/ecommerce-mf/5d1a48da-8ba8-4995-945d-9b31f2b7d223-2.png?auto=format&fit=clip'
  },
  url: {
    absoluteUrl: /*#__PURE__*/"".concat(CREHANA_BASE_URL_PRD, "/blog/desempeno/herramientas-evaluacion-desempeno/"),
    relativeUrl: '/blog/desempeno/herramientas-evaluacion-desempeno/'
  },
  title: 'Herramientas de evaluación de desempeño: 17 técnicas para medir el rendimiento de tu equipo y ¡elevar su productividad!'
},
// 3
{
  image: {
    placeholder: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAIAAADZSiLoAAAAKUlEQVR4nAEeAOH/AVNUXvXm3v8NFAQCAwYI8vL99vsECO7k9+bm5/L23EEROcPavakAAAAASUVORK5CYII=',
    url: 'https://crehana-vercel-images-prd.imgix.net/public/ecommerce-mf/3b29fb32-9e7e-4709-96c3-74997e32883e-3.png?auto=format&fit=clip'
  },
  url: {
    absoluteUrl: /*#__PURE__*/"".concat(CREHANA_BASE_URL_PRD, "/blog/gestion-talento/como-capacitar-equipo/"),
    relativeUrl: '/blog/gestion-talento/como-capacitar-equipo/'
  },
  title: '¿Cómo capacitar equipos en empresas de más de 500 empleados?'
},
// 4
{
  image: {
    placeholder: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAIAAADZSiLoAAAAKUlEQVR4nAEeAOH/AVNUXvXm3v8NFAQCAwYI8vL99vsECO7k9+bm5/L23EEROcPavakAAAAASUVORK5CYII=',
    url: 'https://crehana-vercel-images-prd.imgix.net/public/ecommerce-mf/9d57bd6f-b427-4b7d-8dce-dc03afce27fd-4.png?auto=format&fit=clip'
  },
  url: {
    absoluteUrl: /*#__PURE__*/"".concat(CREHANA_BASE_URL_PRD, "/blog/gestion-talento/comunicacion-continua/"),
    relativeUrl: '/blog/gestion-talento/comunicacion-continua/'
  },
  title: '¿Cómo diseñar una estrategia de comunicación continua? Guía para grandes empresas'
},
// 5
{
  image: {
    placeholder: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAIAAADZSiLoAAAAKUlEQVR4nAEeAOH/AVNUXvXm3v8NFAQCAwYI8vL99vsECO7k9+bm5/L23EEROcPavakAAAAASUVORK5CYII=',
    url: 'https://crehana-vercel-images-prd.imgix.net/public/ecommerce-mf/bb919579-0488-4a9b-808a-5e4eed7a22e3-5.png?auto=format&fit=clip'
  },
  url: {
    absoluteUrl: /*#__PURE__*/"".concat(CREHANA_BASE_URL_PRD, "/blog/clima-laboral/que-es-clima-organizacional/"),
    relativeUrl: '/blog/clima-laboral/que-es-clima-organizacional/'
  },
  title: '¿Qué es el clima organizacional?: ¡el éxito de tu empresa pasa por tu equipo!'
},
// 6
{
  image: {
    placeholder: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAIAAADZSiLoAAAAKUlEQVR4nAEeAOH/AVNUXvXm3v8NFAQCAwYI8vL99vsECO7k9+bm5/L23EEROcPavakAAAAASUVORK5CYII=',
    url: 'https://crehana-vercel-images-prd.imgix.net/public/ecommerce-mf/6c835704-5c48-4b09-82f0-8725e18dca0a-6.png?auto=format&fit=clip'
  },
  url: {
    absoluteUrl: /*#__PURE__*/"".concat(CREHANA_BASE_URL_PRD, "/blog/desempeno/desempeno-laboral/"),
    relativeUrl: '/blog/desempeno/desempeno-laboral/'
  },
  title: '¿Cómo transformar el desempeño laboral en resultados efectivos? Guía para empresas de +500 empleados'
},
// 7
{
  image: {
    placeholder: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAIAAADZSiLoAAAAKUlEQVR4nAEeAOH/AVNUXvXm3v8NFAQCAwYI8vL99vsECO7k9+bm5/L23EEROcPavakAAAAASUVORK5CYII=',
    url: 'https://crehana-vercel-images-prd.imgix.net/public/ecommerce-mf/1fe0f87c-60e1-40e4-9981-d786e3d40a32-7.png?auto=format&fit=clip'
  },
  url: {
    absoluteUrl: /*#__PURE__*/"".concat(CREHANA_BASE_URL_PRD, "/blog/desempeno/modelos-evaluacion-desempeno/"),
    relativeUrl: '/blog/desempeno/modelos-evaluacion-desempeno/'
  },
  title: 'Modelos de evaluación de desempeño: ¿cuáles debería implementar para medir a mi equipo?'
},
// 8
{
  image: {
    placeholder: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAIAAADZSiLoAAAAKUlEQVR4nAEeAOH/AVNUXvXm3v8NFAQCAwYI8vL99vsECO7k9+bm5/L23EEROcPavakAAAAASUVORK5CYII=',
    url: 'https://crehana-vercel-images-prd.imgix.net/public/ecommerce-mf/35d2bdb9-9120-4b71-b63f-f79f0abf70f6-8.png?auto=format&fit=clip'
  },
  url: {
    absoluteUrl: /*#__PURE__*/"".concat(CREHANA_BASE_URL_PRD, "/blog/gestion-talento/potencial-humano/"),
    relativeUrl: '/blog/gestion-talento/potencial-humano/'
  },
  title: 'Potencial humano: ¿Cómo medirlo y desarrollar un plan de talento masivo para tu equipo?'
},
// 9
{
  image: {
    placeholder: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAIAAADZSiLoAAAAKUlEQVR4nAEeAOH/AVNUXvXm3v8NFAQCAwYI8vL99vsECO7k9+bm5/L23EEROcPavakAAAAASUVORK5CYII=',
    url: 'https://crehana-vercel-images-prd.imgix.net/public/ecommerce-mf/fe693cd0-811d-44b8-ba3f-f951099133b7-9.png?auto=format&fit=clip'
  },
  url: {
    absoluteUrl: /*#__PURE__*/"".concat(CREHANA_BASE_URL_PRD, "/blog/reclutamiento-contratacion/como-hacer-evaluacion-desempeno/"),
    relativeUrl: '/blog/reclutamiento-contratacion/como-hacer-evaluacion-desempeno/'
  },
  title: '¿Cómo evaluar el desempeño de un empleado? 6 pasos para impulsar la productividad laboral'
},
// 10
{
  image: {
    placeholder: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAIAAADZSiLoAAAAKUlEQVR4nAEeAOH/AVNUXvXm3v8NFAQCAwYI8vL99vsECO7k9+bm5/L23EEROcPavakAAAAASUVORK5CYII=',
    url: 'https://crehana-vercel-images-prd.imgix.net/public/ecommerce-mf/b11716a6-86a7-4d13-926e-6c42e32ad514-10.png?auto=format&fit=clip'
  },
  url: {
    absoluteUrl: /*#__PURE__*/"".concat(CREHANA_BASE_URL_PRD, "/blog/desempeno/medir-trabajo-en-equipo/"),
    relativeUrl: '/blog/desempeno/medir-trabajo-en-equipo/'
  },
  title: '¿Tu empresa sigue creciendo? Conoce cómo medir el trabajo en equipo para conformar un team de alto rendimiento'
}];
export var PageNotFound = function PageNotFound() {
  var _useTranslation = useTranslation(),
    languageCode = _useTranslation.languageCode;
  var isClient = useIsClient();
  if (!isClient) {
    return null;
  }

  // it's ok to have these strings here because this component will not be customized by the user
  var title = {
    es: '¡Ups! No encontramos la página que estabas buscando...',
    en: 'Oops! We can’t find the page you’re looking for...',
    pt: 'Ops! Não conseguimos encontrar a página que você está procurando...'
  };
  var description = {
    es: {
      one: 'Mientras estes aquí, te mostramos algunos artículos de',
      two: 'nuestro blog',
      three: 'que podrían interesarte'
    },
    en: {
      one: 'While you are here, we show you some articles from',
      two: 'our blog',
      three: 'that may interest you'
    },
    pt: {
      one: 'Enquanto você está aqui, mostramos alguns artigos de',
      two: 'nosso blog',
      three: 'que podem te interessar'
    }
  };
  return /*#__PURE__*/_jsx("div", {
    className: "tw-bg-info-100 tw-w-screen tw-h-screen tw-overflow-hidden",
    children: /*#__PURE__*/_jsxs("div", {
      className: "tw-pt-4.4 tw-px-1.6 sm:tw-px-3.2 lg:tw-px-14.4 xl:tw-px-28 tw-h-full",
      children: [_div || (_div = /*#__PURE__*/_jsx("div", {
        className: "tw-w-full tw-flex tw-justify-center sm:tw-justify-start",
        children: /*#__PURE__*/_jsx(LazyImage, {
          src: "https://crehana-public-catalog.imgix.net/organization/logos/2023/09/12/054b5c49b350437a8fc7c81650448c49.png",
          alt: "Crehana",
          className: "tw-w-16.4 tw-h-[24px]"
        })
      })), /*#__PURE__*/_jsxs("div", {
        className: "tw-text-center tw-mt-8 tw-flex tw-flex-col tw-gap-0.8",
        children: [/*#__PURE__*/_jsx("h1", {
          className: "tw-font-subtitle1 sm:tw-font-h3 tw-font-semibold",
          children: title[languageCode]
        }), /*#__PURE__*/_jsxs("p", {
          className: "tw-font-body5 sm:tw-font-body4",
          children: [/*#__PURE__*/_jsx("span", {
            children: description[languageCode].one
          }), ' ', /*#__PURE__*/_jsx("a", {
            className: "tw-underline",
            href: "/blog",
            children: description[languageCode].two
          }), ' ', /*#__PURE__*/_jsx("span", {
            children: description[languageCode].three
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "tw-relative tw-mt-7.2 sm:tw-mt-8.8 tw-w-auto md:tw-w-[79rem] tw-mx-auto tw-text-center",
          children: [_span || (_span = /*#__PURE__*/_jsx("span", {
            className: "tw-inline-block tw-overflow-hidden tw-text-[14.1308rem] tw-leading-[11.5rem] tw-tracking-15 sm:tw-text-[29.2571rem] md:tw-text-[36.3365rem] sm:tw-leading-[28rem] sm:tw-tracking-[3.3435rem] tw-font-pop tw-font-semibold tw-text-primary-light-500",
            children: "404"
          })), articles.length === 10 ? /*#__PURE__*/_jsxs("div", {
            className: "tw-absolute tw-inset-0",
            children: [/*#__PURE__*/_jsxs("div", {
              className: "tw-flex tw-h-[33%]",
              children: [/*#__PURE__*/_jsx(ArticleCard, {
                article: articles[0]
              }), _CardWrapper || (_CardWrapper = /*#__PURE__*/_jsx(CardWrapper, {})), /*#__PURE__*/_jsx(ArticleCard, {
                article: articles[1]
              }), _CardWrapper2 || (_CardWrapper2 = /*#__PURE__*/_jsx(CardWrapper, {})), _CardWrapper3 || (_CardWrapper3 = /*#__PURE__*/_jsx(CardWrapper, {})), _CardWrapper4 || (_CardWrapper4 = /*#__PURE__*/_jsx(CardWrapper, {})), /*#__PURE__*/_jsx(ArticleCard, {
                article: articles[2],
                imgStyle: {
                  objectPosition: '63% 0px'
                }
              }), _CardWrapper5 || (_CardWrapper5 = /*#__PURE__*/_jsx(CardWrapper, {})), /*#__PURE__*/_jsx(ArticleCard, {
                article: articles[3]
              })]
            }), /*#__PURE__*/_jsxs("div", {
              className: "tw-w-full tw-flex tw-h-[33%]",
              children: [_CardWrapper6 || (_CardWrapper6 = /*#__PURE__*/_jsx(CardWrapper, {})), _CardWrapper7 || (_CardWrapper7 = /*#__PURE__*/_jsx(CardWrapper, {})), _CardWrapper8 || (_CardWrapper8 = /*#__PURE__*/_jsx(CardWrapper, {})), /*#__PURE__*/_jsx(ArticleCard, {
                article: articles[4]
              }), _CardWrapper9 || (_CardWrapper9 = /*#__PURE__*/_jsx(CardWrapper, {})), /*#__PURE__*/_jsx(ArticleCard, {
                article: articles[5]
              }), _CardWrapper0 || (_CardWrapper0 = /*#__PURE__*/_jsx(CardWrapper, {})), _CardWrapper1 || (_CardWrapper1 = /*#__PURE__*/_jsx(CardWrapper, {})), _CardWrapper10 || (_CardWrapper10 = /*#__PURE__*/_jsx(CardWrapper, {}))]
            }), /*#__PURE__*/_jsxs("div", {
              className: "tw-w-full tw-flex tw-h-[33%]",
              children: [/*#__PURE__*/_jsx(ArticleCard, {
                article: articles[6],
                imgStyle: {
                  objectPosition: '63% 0px'
                }
              }), _CardWrapper11 || (_CardWrapper11 = /*#__PURE__*/_jsx(CardWrapper, {})), /*#__PURE__*/_jsx(ArticleCard, {
                article: articles[7]
              }), _CardWrapper12 || (_CardWrapper12 = /*#__PURE__*/_jsx(CardWrapper, {})), _CardWrapper13 || (_CardWrapper13 = /*#__PURE__*/_jsx(CardWrapper, {})), _CardWrapper14 || (_CardWrapper14 = /*#__PURE__*/_jsx(CardWrapper, {})), /*#__PURE__*/_jsx(ArticleCard, {
                article: articles[8]
              }), _CardWrapper15 || (_CardWrapper15 = /*#__PURE__*/_jsx(CardWrapper, {})), /*#__PURE__*/_jsx(ArticleCard, {
                article: articles[9],
                imgStyle: {
                  objectPosition: '63% 0px'
                }
              })]
            })]
          }) : null]
        })]
      })]
    })
  });
};
var ArticleCard = function ArticleCard(_ref) {
  var article = _ref.article,
    imgStyle = _ref.imgStyle;
  return /*#__PURE__*/_jsxs(CardWrapper, {
    className: "tw-relative",
    children: [/*#__PURE__*/_jsxs("a", {
      className: "tw-peer tw-relative tw-block tw-h-full tw-w-full md:tw-w-[9.3rem] tw-z-0 sm:hover:tw-z-2 sm:hover:tw-opacity-0 tw-transition-opacity",
      href: article.url.absoluteUrl,
      children: [/*#__PURE__*/_jsx(LazyImage, {
        src: article.image.url,
        alt: article.title,
        className: "tw-w-full tw-h-full tw-rounded-0.8 sm:tw-rounded-1.6",
        imgClassName: "tw-w-full tw-object-cover tw-rounded-0.8 sm:tw-rounded-1.6",
        imgStyle: _objectSpread(_objectSpread({}, imgStyle), {}, {
          height: '100%',
          width: '100%'
        })
      }), _span2 || (_span2 = /*#__PURE__*/_jsx("span", {
        className: "tw-absolute tw-bottom-0 tw-right-0 tw-rounded-tl-0.8 tw-rounded-br-0.8 sm:tw-rounded-tl-1.6 sm:tw-rounded-br-1.6 tw-h-[40%] tw-w-[40%] tw-bg-primary-light-100 tw-flex tw-items-center tw-justify-center",
        children: /*#__PURE__*/_jsx(ArrowRight, {
          size: 20,
          className: "tw-text-primary-light-500"
        })
      }))]
    }), /*#__PURE__*/_jsxs("div", {
      className: "tw-hidden sm:tw-flex md:peer-hover:tw-opacity-100 md:peer-hover:tw-z-1 md:peer-hover:tw-pointer-events-auto tw-opacity-0 tw-pointer-events-none tw-transition-opacity tw-absolute tw-rounded-0.8 sm:tw-rounded-1.6 tw-left-[-96%] tw-top-[-50%] tw-w-[280%] tw-h-[220%] tw-flex-col tw-justify-end tw-gap-0.8 tw-p-1.2",
      children: [/*#__PURE__*/_jsx(LazyImage, {
        src: article.image.url,
        alt: article.title,
        className: "tw-w-full tw-h-full tw-rounded-0.8 sm:tw-rounded-1.6 tw-absolute tw-inset-0",
        imgClassName: "tw-w-full tw-object-cover tw-rounded-0.8 sm:tw-rounded-1.6",
        imgStyle: _objectSpread({}, imgStyle)
      }), /*#__PURE__*/_jsx("div", {
        style: {
          background: 'linear-gradient(0deg, rgb(0 0 0 / 77%) 0%, rgb(255 255 255 / 19%) 100%)'
        },
        className: "tw-absolute tw-inset-0 tw-rounded-0.8 sm:tw-rounded-1.6"
      }), /*#__PURE__*/_jsx("span", {
        className: "tw-relative tw-text-primary-light-100 tw-font-link2",
        children: article.title
      }), _span3 || (_span3 = /*#__PURE__*/_jsx("span", {
        className: "tw-relative tw-ml-auto",
        children: /*#__PURE__*/_jsx(ArrowRight, {
          size: 24,
          className: "tw-text-primary-light-100"
        })
      }))]
    })]
  });
};
var CardWrapper = function CardWrapper(_ref2) {
  var children = _ref2.children,
    className = _ref2.className;
  return /*#__PURE__*/_jsx("div", {
    className: "tw-w-[11%] sm:tw-min-w-[3.4rem] tw-max-h-[3.4rem] sm:tw-max-h-[7.1rem] md:tw-max-h-max tw-max-w-8.8 tw-h-full ".concat(className),
    children: children
  });
};